import { isReservationPayment, isFinalSettlementPayment } from "../../../services/agreementsService";
import { getDiscountedPricesForProduct, getCalculatedPricingForProductDiscounted } from "../../../utils";
import { roundToDecimalPlaces } from "../../../helpers/methods";

/**
 * Returns an object mapping product id to summed percentage for this product across all payments
 * Reservation and FinallSettlement payments are not counted towards the total
 */
export const calculateTotalPercentagePerProduct = (payments) => {
    const tranches = payments.filter((p) =>  !isReservationPayment(p) && !isFinalSettlementPayment(p));
    const accumulator = Object.fromEntries(
        tranches.flatMap((payment) =>
            payment.per_product_percentages.map((pp) => [pp.product_id, 0]),
        ),
    );

    return tranches.reduce((acc, payment) => {
        payment.per_product_percentages.forEach((pp) => {
            acc[pp.product_id] += pp.percentage;
        });
        return acc;
    }, accumulator);
};

export const calculateTotalPricePerProduct = (payments, products, productDiscounts) => {
    const tranches = payments.filter((p) =>  !isReservationPayment(p) && !isFinalSettlementPayment(p));
    const accumulator = Object.fromEntries(
        tranches.flatMap((payment) =>
            payment.per_product_percentages.map((pp) => [pp.product_id, 0]),
        ),
    );

    const productsMap = products.reduce((map, product) => {
            map[product.id] = product;
            return map;
    }, {})

    return tranches.reduce((acc, payment) => {
        payment.per_product_percentages.forEach((pp) => {
            const discount = productDiscounts?.[pp.product_id] ?? 0;
            const product = productsMap[pp.product_id]
            const pricing = getDiscountedPricesForProduct(
                product,
                discount,
            );
            const grossPrice = pricing.gross;
            const grossAmount = roundToDecimalPlaces((pp.percentage / 100) * grossPrice, 2)

            acc[pp.product_id] += grossAmount;
        });
        return acc;
    }, accumulator);
};


export const calculateTotalAgreementPrice = (products, productDiscounts) => {
    const productPricings = products.map((product) =>
        getCalculatedPricingForProductDiscounted(product, productDiscounts[product.id]),
    );

    const totalListedGross = productPricings.reduce(
        (sum, pricing) => sum + roundToDecimalPlaces(pricing.listed.gross,2),
        0,
    );

    const totalListedNet = productPricings.reduce(
        (sum, pricing) => sum +  roundToDecimalPlaces(pricing.listed.net,2),
        0,
    );

    return {
        totalListedGross,
        totalListedNet,
    };
};